import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    dark: true,
    themes: {
      dark: {
        // primary: '#154E7D',
        // secondary: '#313534',
        // accent: '#32A6AD',
        danger: '#cc2e2e',
        warning: '#cfaa30',
        success: '#097c12',
        // info: '#4E7D89',
        bg_dark: '#121212',
        bg_darker: '#212121',
        bg_darkerish: '#262626',
        bg_darkish: '#333333',
        disabled: '#767676',
        dw_green: '#8dc63f',
        dw_grey: '#969695',
        dw_charcoal: '#383432'
      }
    }
  }
});
